import { render } from "./BinaryItem.vue?vue&type=template&id=4fb54333&scoped=true"
import script from "./BinaryItem.vue?vue&type=script&lang=js"
export * from "./BinaryItem.vue?vue&type=script&lang=js"

import "./BinaryItem.vue?vue&type=style&index=0&id=4fb54333&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb54333"]])

export default __exports__